import { IInvoiceItemResponse } from "../../services/invoice-view/invoice-view.interface";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import PaymentHistoryCard from "../PaymentHistoryCard/PaymentHistoryCard";
import React from "react";

interface IPaymentHistoryCardList{
  paymentDetailsList: IInvoiceItemResponse[];
  handleInvoiceDownload: (invoiceId: string) => void;
  petList: IPetItemResponse[];
}

const PaymentHistoryCardList = ({ paymentDetailsList, handleInvoiceDownload, petList }: IPaymentHistoryCardList) => {
  return (
    <>
      {paymentDetailsList?.map((detail) => (
        <PaymentHistoryCard key={detail.id} paymentDetail={detail} handleInvoiceDownload={handleInvoiceDownload}
          petList={petList}/>
      ))}
    </>
  );
};

export default PaymentHistoryCardList;
